import styled from 'styled-components';

export const SidebarWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 200px;
  background-color: ${({ theme }) => theme.elements.defaultWhite};
  padding: 10px;
  border-right: 1px solid ${({ theme }) => theme.elements.borderGrey};
`;

export const SidebarLogo = styled.img`
  width: 115%;
  margin: 0 0 15px 0;
`;
